<template>
  <div class="page-template" v-loading="loading">
    <search-form-template
      :searchOptions="situationSearchOptions"
      @searchSubmit="searchSubmit"
      @clear="clearSearch"
      :toolConfig="toolConfig"
      @btnCommon="exportExcelData()"
    ></search-form-template>
    <table-template ref="situation" :tableOptions="situationTable"></table-template>
  </div>
</template>

<script>
  import searchFormTemplate from '@/components/template/searchFormTemplate';
  import tableTemplate from '@/components/template/tableTemplate';
  import api from '@/config/api';
  import userPower from '@/mixin/userPower'

  export default {
    mixins: [userPower],
    name: 'RoleManager',
    components: {
      tableTemplate,
      searchFormTemplate,
    },
    data() {
      return {
        activeTab: 'situation',
        loading: false,
        treeConfig: {
          id: 'menuTree',
          showCheckbox: true,
          data: [],
          nodeKey: 'id',
          defaultProps: {
            children: 'children',
            label: 'name'
          },
          request: {
            api: api.system.rolePrivilege,
            param: {roleId: ''}
          }
        },

        // 更多功能
        toolConfig: [
          {
            label: '打印',
            code: 'print'
          },
          {
            label: '导出',
            code: 'export',
            callback: this.exportExcelData
          }
        ],

        // 收银日报
        situationSearchOptions: {
          simple: [],
          complex: [
            {
              label: '选择日期',
              prop: 'CreateDttm',
              type: 'dateTimeRangeButton',
              dateType: 'datetime',
              span: 24
            },
            {
              label: '门店名称',
              type: 'select',
              prop: 'storeId',
              data: [],
              isHasAll: true,
              span: 12,
              url: api.system.seStore
            }
          ]
        },
        //收银日报
        situationTable: {
          showSummary: true,
          summaryColumns: ['customerCount', 'amountReceived'],
          indexShow: true,//是否显示索引
          indexMethod: (index) => {//自定义列索引
            return index + 1;
          },
          columns: [
            {
              label: '销售时段',
              prop: 'dayDate',
              width: '90',
              align: 'center'
            },
            {
              label: '客单量',
              prop: 'customerCount',
              width: '100',
              align: 'center'
            },
            {
              label: '客单占比',
              prop: 'customerProportion',
              width: '100',
              align: 'center',
            },
            {
              label: '销售金额',
              prop: 'amountReceived',
              width: '100',
              align: 'center'
            },
            {
              label: '金额占比',
              prop: 'moneyProportion',
              width: '100',
              align: 'center',
            },
            {
              label: '平均客单价',
              prop: 'avgMoney',
              width: '100',
              align: 'center'
            }
          ],
          // url: api.retail.situation
        },

      };
    },
    created() {
      this.title = document.title;
      this.setStore(this.situationSearchOptions.complex);
    },
    mounted() {
      if (Object.keys(this.$route.params).length > 0 && (this.$route.params.code === '7' || this.$route.params.code === '8')) {
        this.situationTable.param = this.$route.params.timeParam
      }
      this.$nextTick(() => {
        this.situationTable.url = api.retail.timeAnalysis
        this.$refs['situation'].operationSuccess();
      })
    },
    methods: {
      searchSubmit(param) {
        this.$refs[this.activeTab].searchParam = param;
        this.$refs[this.activeTab].operationSuccess();
      },
      tabChange() {
        this.$refs[this.activeTab].operationSuccess();
      },
      clearSearch() {
        this.$refs['situation'].clearSearch();
      },
      exportExcelData() {
        const loading = this.$loading({
          lock: true,
          text: '正在导出...',
          background: 'rgba(225, 225, 225, 0.8)'
        });
        let param = this.$refs["situation"].searchParam;
        this.$axios.PostBlob(api.retail.customerAnalysisExport, param).then(res => {
          if (res.status === 200) {
            const fileName = '客单时段分析_' + this.$utils.getDateTime() + ".xlsx";
            let blob = new Blob([res.data])
            let downloadElement = document.createElement('a');
            let href = window.URL.createObjectURL(blob); //创建下载的链接
            downloadElement.href = href;
            downloadElement.download = fileName; //下载后文件名
            document.body.appendChild(downloadElement);
            downloadElement.click(); //点击下载
            document.body.removeChild(downloadElement); //下载完成移除元素
            window.URL.revokeObjectURL(href); //释放掉blob对象
            this.$notify({
              type: "success",
              title: '导出操作',
              message: '成功!文件名称:' + fileName,
              showClose: false,
            });
            // this.$message.success("导出成功,文件名称:" + fileName);
          } else {
            this.$notify({
              type: "error",
              title: '导出操作',
              message: '失败',
              showClose: false,
            });
            // this.$message.error("导出失败,请稍后再试");
          }
        }).catch(() => {
          this.$message.warning("当前导出数据为空或超出10000条。");
        }).finally(() => {
          loading.close();
        });
      },
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/retail/query/customer/TimeAnalysis.vue